import { FlexibleColumn } from '@ip-only/front-end-library';

const idColumn: FlexibleColumn = {
  id: 'ductId',
  header: 'duktsSidebar.ductId',
  narrow: true,
};

const typeColumn: FlexibleColumn = {
  id: 'type',
  header: 'duktsSidebar.type',
  narrow: true,
};

const colorColumn: FlexibleColumn = {
  id: 'color',
  header: 'duktsSidebar.color',
  narrow: true,
};

export const ductInformationColumns = [idColumn, typeColumn, colorColumn];
